/**
 * @module components\ghTable\dataTable\dataRow\dataCell\rangeCell
 */
import Vue from "vue";
import Component from "vue-class-component";
import DataCellBase from "../dataCellBase";
import { Watch } from "vue-property-decorator";

@Component
export default class RangeCell extends DataCellBase {
  private range: IRange = {};

  @Watch("value")
  private observeValue() {
    if (this.value) {
      if (this.value instanceof Object) {
        this.range = this.value;
        return;
      }
    }
    this.range = {};
  }

  mounted() {
    this.observeValue();
  }

  private get lowSymbol() {
    if (this.range) {
      if (this.range.includeLower) {
        return "[";
      }
    }
    return "(";
  }

  private set lowSymbol(val: string) {
    let flag = false;
    if (val === "[") {
      flag = true;
    }
    this.$set(this.range, "includeLower", flag);
  }

  private get upperSymbol() {
    if (this.range) {
      if (this.range.includeUpper) {
        return "]";
      }
    }
    return ")";
  }

  private set upperSymbol(val: string) {
    let flag = val === "]" ? true : false;
    this.$set(this.range, "includeUpper", flag);
  }

  private rangeSymbol = "~";
}
